import { createContext, useContext } from 'react';
import { useNavigate } from 'react-router-dom';

export const ScientistViewContext = createContext({ active: false, actualUser: null, enter: () => false, exit: () => false });
export const useScientistView = () => useContext(ScientistViewContext);

// Presentation only: identity, token, email, scopes and persisted role stay intact.
export function scientistViewUser(user, active) {
  return active && user?.role === 'admin' ? { ...user, role: 'scientist', ui_preview: 'scientist' } : user;
}

export function confirmViewChange() {
  const event = new Event('beforeunload', { cancelable: true });
  window.dispatchEvent(event);
  return !event.defaultPrevented || window.confirm('Switch views and discard unsaved editor changes?');
}

export function ScientistViewBanner() {
  const { active, actualUser, exit } = useScientistView();
  const navigate = useNavigate();
  if (!active) return null;
  return <aside role="status" aria-label="Scientist view preview" className="fixed bottom-3 right-3 z-[80] max-w-[calc(100vw-24px)] rounded-lg border border-blue-300 bg-blue-50 px-4 py-3 shadow-lg">
    <div className="flex flex-wrap items-center gap-3"><div><strong className="block text-sm text-blue-950">Scientist view</strong><span className="block text-xs text-blue-900">Signed in as {actualUser?.full_name || actualUser?.name || actualUser?.email} (admin). Your identity and administrator access stay unchanged.</span><span className="block text-xs text-blue-900">Use the Scientist filter to preview that person’s To do today.</span></div><button type="button" className="rounded border border-blue-400 bg-white px-3 py-2 text-sm font-semibold text-blue-950" onClick={() => { if (exit()) navigate('/projects'); }}>Exit scientist view</button></div>
  </aside>;
}
